import { render, staticRenderFns } from "./workerSettingPage.vue?vue&type=template&id=c1681816&"
import script from "./workerSettingPage.vue?vue&type=script&lang=ts&"
export * from "./workerSettingPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports